import { BusinessSlug } from './business-slug.enum';
import { EtxeApiPrefixes, EtxeApiSlugs } from './etxe/api-slugs.enum';

export type BusinessApiSlugs = EtxeApiSlugs;

export type BusinessApiPrefix = EtxeApiPrefixes;

export const BusinessApiSlugsMap = {
  [BusinessSlug.ETXE]: EtxeApiSlugs,
} as const;
